import type { DashboardFilters } from '@myapp/contract'
import { normalizeFilters } from '../../../shared/lib/normalizeFilters'

export const dashboardKeys = {
  all: ['dashboard'] as const,
  aggregates: () => [...dashboardKeys.all, 'aggregates'] as const,
  aggregate: (filters?: DashboardFilters) =>
    [...dashboardKeys.aggregates(), normalizeFilters(filters)] as const,
}
